/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, Row } from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Loading } from '@folio/stripes-components';
import FieldViewBuilder from '../../../shared/FieldViewBuilder';
import DataProvider from '../../../providers/DataProvider';
import HelpeProvider from '../../../providers/HelpeProvider';
import useControlledVocab from '../../../hooks/useDataQueries';

function HoldingView({ holdingData, templateTypeId }) {
  const { data, pending } = useControlledVocab();
  const intl = useIntl();

  const defaultTemplate = useMemo(() => {
    if (!pending) {
      return data.templates.find((template) => template.isDefault === true);
    }
    return {};
  }, [pending]);

  const currentTemplate = useMemo(() => {
    if (!pending) {
      return data.templates.find((template) => template.id === templateTypeId);
    }
    return {};
  }, [data.templates, pending, templateTypeId]);

  const localizedTemplateName = useMemo(() => {
    if (!pending) {
      return (currentTemplate || defaultTemplate)?.name?.find(
        (field) => field?.locale === intl.locale,
      )?.value;
    }
    return '';
  }, [pending, templateTypeId]);

  return (
    <DataProvider>
      <HelpeProvider>
        {pending && <Loading size="large" />}
        {!pending && (
          <div>
            <Row>
              <Col xs={12}>
                <KeyValue
                  label={
                    <FormattedMessage
                      id="ui-plugin-inventory-templates.instanceWizard.instanceData.fields.templateType.label"
                      defaultMessage="Template type"
                    />
                  }
                  value={
                    <Icon icon={currentTemplate?.icon || 'document'}>
                      {localizedTemplateName}
                    </Icon>
                  }
                />
              </Col>
            </Row>
            <FieldViewBuilder
              data={{ ...holdingData, holdingHrid: holdingData.hrid }}
              template={currentTemplate || defaultTemplate}
              entityType="holdings"
              controlledVocab={data}
            />
            <div />
          </div>
        )}
      </HelpeProvider>
    </DataProvider>
  );
}

HoldingView.propTypes = {
  holdingData: PropTypes.object,
  templateTypeId: PropTypes.string,
};

export default HoldingView;
